import { render, staticRenderFns } from "./award-screen.vue?vue&type=template&id=01fbca4a&"
import script from "./award-screen.vue?vue&type=script&lang=js&"
export * from "./award-screen.vue?vue&type=script&lang=js&"
import style0 from "./award-screen.vue?vue&type=style&index=0&id=01fbca4a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports